<template>
  <div class="col-12 text-end" v-if="visible">
    <div class="popup_bg"></div>
    <div id="myModal" class="modal_class">
      <div class="modal-content invoice" style="max-width: 400px !important">
        <div class="d-flex justify-content-between">
          <span>Update Data</span>
          <span @click="$emit('close')" class="close">&times;</span>
        </div>

        <div class="hover-popup my-3">
          <div class="popup-content">
            <div class="row justify-content-center">
              <div class="mb-3 p-3">
                <div class="col-12 col-sm-12 mb-3">
                  <div>
                    <textarea
                      v-model="localFormData.PPPOE_ID"
                      type="textarea"
                      rows="4"
                      placeholder="PPPOE ID"
                      class="form-control invoice-card"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-12 mb-3">
                  <div>
                    <input
                      v-model="localFormData.port_number"
                      type="text"
                      placeholder="Port Number"
                      class="form-control invoice-card"
                    />
                  </div>
                </div>
              </div>
              <div class="flex text-center">
                <div class="grid grid-cols-2 gap-2">
                  <button class="btn btn-secondary mx-3" @click="$emit('close')">
                    Cancel
                  </button>
                  <button class="btn btn-success" @click="$emit('submit', localFormData)">
                    Update
                    <span
                      v-if="loading"
                      class="spinner-border spinner-border-sm mx-3"
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({
        PPPOE_ID: "",
        port_number: "",
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localFormData: { ...this.formData },
    };
  },
  emits: ['close', 'submit'],
  watch: {
    formData: {
      handler(newVal) {
        this.localFormData = { ...newVal };
      },
      deep: true,
    },
  },
};
</script>

